import axios from '@/services/axiosConfig'

const endPoint = {
	signin: '/user/signin',
	lookupUserInfo: '/user',
	lookupUserInstInfo: '/user/institute',
	sendEmailCocde: '/user/email/code',
	logout: '/user/signout',
	lookupNotice: (offset, length) =>
		`user/notification/list?offset=${offset}&length=${length}`,
	readNotice: '/user/notification/read',
	lookupUserPermission: '/user/permission/essence',
	lookupLicense: instId => `/institute/${instId}/license`,
}

const userAPI = {
	signin: data => axios.post(endPoint.signin, data),
	lookupUserInfo: () => {
		return axios.get(endPoint.lookupUserInfo)
	},
	lookupUserInstInfo: () => {
		return axios.get(endPoint.lookupUserInstInfo)
	},
	updateUserInfo: body => {
		return axios.put(endPoint.lookupUserInfo, body)
	},
	sendEmailCocde: body => {
		return axios.post(endPoint.sendEmailCocde, body)
	},
	logout: () => {
		return axios.post(endPoint.logout)
	},
	withdrawal: () => {
		return axios.delete(endPoint.lookupUserInfo)
	},
	lookupNotice: (offset, length) => {
		return axios.get(endPoint.lookupNotice(offset, length))
	},
	readNotice: ids => {
		return axios.put(endPoint.readNotice, ids)
	},
	lookupUserPermission: () => axios.get(endPoint.lookupUserPermission),
	lookupLicense: instId => axios.get(endPoint.lookupLicense(instId)),
}

export default userAPI
